export const anyMenuHasPickDate = (menus: any[], orderType: string | undefined) => {
    return menus.some((menu: any) => !orderType || (menu[orderType.toLowerCase()] === true && menu.pick_date));
}